import React from 'react'
import { useSelector } from '~/store/hooks'

import Helmet from 'react-helmet'
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import Accordion from '~/components/core/accordion'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'
import ButtonArrow from '~/components/core/buttonArrow'
import { Wondering } from '~/icons/Wondering'
import trads from '~/intl/trads.json'

const Faq = ({ data, profile = null, currentContact = null }) => {
  const lang = useSelector((state) => state.lang)

  const items = data.faqItems ? data.faqItems : data.items
  const title = data.faqTitle ? data.faqTitle : trads[lang].faq.title

  const helmetDatas = []

  items.forEach((faq) => {
    const item = faq.fields ? faq.fields : faq
    const question = faq.fields ? item.question : item.question.question
    const answer = faq.fields ? item.answer : item.answer.json

    const helmetObject = {
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: documentToPlainTextString(answer),
      },
    }

    helmetDatas.push(JSON.stringify(helmetObject))
  })

  return (
    <>
      <div className="questions__title">
        <h2
          className={`flex-grow text-purple ${profile ? 'title-2-bold' : 'title-2-uppercase'}`}
        >
          {title}
        </h2>
        <Wondering className="icon" />
      </div>

      <div className="questions__content">
        {items.map((faq, i) => {
          const item = faq.fields ? faq.fields : faq
          const question = item.question.question ? item.question.question : item.question;
          const answer = item.answer

          return (
            <Accordion
              key={i}
              prefixClass="accordion-faq"
              buttonType="chevron"
              button={question}
            >
              <Wysiwyg document={answer} />
            </Accordion>
          )
        })}
      </div>

      {profile && (
        <div className="flex justify-center md:justify-end mt-10">
          <ButtonArrow
            text={`${trads[lang].faq.linkPart1} ${profile.toLowerCase()} ${trads[lang].faq.linkPart2}`}
            link={currentContact}
            color="purple"
          />
        </div>
      )}

      <Helmet>
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [${helmetDatas}]
          }
        `}</script>
      </Helmet>
    </>
  )
}

export default Faq
